import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: ${(props) => props.width || "100%"};
  padding: ${(props) => props.padding || "1rem"}; 
  min-width: ${(props) => props.minWidth || "14.875rem"};
  max-width: ${(props) => props.maxWidth || "14.875rem"};

  gap: 1rem;
  display: flex;  
  flex-wrap: ${(props) => props.flexWrap || "nowrap"};
  flex-direction: ${(props) => props.flexDirection || "column"};
  
  border-radius: 1rem;
  background-color: ${(props) => props.backgroundColor || "#F8F8F9"};

  @media (max-width: 1130px) {
    max-width: 100%;

    display: flex;  
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
  }

  @media (max-width: 768px) {
    background-color: transparent;
    margin-bottom: 0;
  }

  @media (max-width: 756px) {
    margin-right: 0;
  }

  @media (max-width: 365px) {
    display: flex;  
    flex-direction: column;
  }
`;

export const CustomSelect = styled.div`
  max-height: 2rem;
  position: relative;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: ${(props) => props.widthCustomSelect || "100%"};
  max-width: 12.25rem;

  @media (max-width: 756px) {
    max-width: 100%;
    max-height: none;
  }
`;

export const SelectButton = styled.div`
  padding: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  border-radius: 1.25rem;
  background: ${(props) => (props.selected ? "#21262F" : "#F8F8F9")};
  border: 1px solid ${theme.colors.gray.Cinza_2};

  color: ${(props) => (props.selected ? "#FFF" : "#21262F")};
`;

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  margin-left: 0.5rem;

  &.open {
    transform: rotate(180deg);
  }

  img {
    width: 16px;
    height: auto;
    filter: ${(props) => (props.selected ? "invert(1)" : "invert(0)")};
  }
`;


export const SelectOptions = styled.div`
  top: 110%;
  z-index: 1;
  width: 100%;
  min-width: ${(props) => props.minWidthOptions ? props.minWidthOptions : "auto" };
  max-height: 15rem;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  background: white;
  border-radius: 0.625rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 756px) {
    position: static;
  }
`;

export const SearchInputContainer = styled.div`
  width: 100%;
  padding: 0.625rem;
  border-bottom: 1px solid #eee;

  input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #E0E0E0;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: ${theme.colors.gray.Cinza_2};
    outline: none;
  }
`;

export const OptionsList = styled.div`
  max-height: 15rem;
  overflow-y: scroll;
  overflow-x: hidden;
  
  &::-webkit-scrollbar {
    width: 0.2rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 1rem;
  }

  @media (max-width: 756px) {
    position: static;

    max-height: 9rem;
  }
`;

export const Option = styled.div`
  padding: 0.625rem;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  align-items: center;
  font-size: 0.8rem;

  &:hover {
    background: #eee;
  }

  input {
    margin-right: 8px;
    cursor: pointer;
  }

  label {
    text-align: start;
  }
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 50px;
  height: 50px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;